export const yuan2Cent = (obj = {}, digit = 100) => {
  if (obj instanceof Object) {
    let opt = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const ele = obj[key]
        let val = ele
        if (val != '' && !isNaN(val)) {
          val = tansfer2Cent(val, digit)
        }
        opt[key] = val
      }
    }
    return opt
  }
  return tansfer2Cent(obj, digit)
}

export const cent2Yuan = (cent = {}) => {
  if (cent instanceof Object) {
    let opt = {}
    for (const key in cent) {
      if (cent.hasOwnProperty(key)) {
        const ele = cent[key]
        opt[key] = transfer2Yuan(ele)
      }
    }
    return opt
  }
  return transfer2Yuan(cent)
}

function tansfer2Cent (val, digit) {
  let m = 0, pnt = val.toString(), snt = digit.toString()
  try { m += pnt.split('.')[1].length } catch (e) { }
  try { m += snt.split('.')[1].length } catch (e) { }
  return Number(pnt.replace('.', '')) * Number(snt.replace('.', '')) / Math.pow(10, m)
}

function transfer2Yuan (cent) {
  var num = (Number(cent) * 0.01) + ''
  var reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
  num = num.replace(reg, '$1')
  num = toDecimal(num)
  return num
}

function toDecimal (val) {
  let fval = parseFloat(val)
  if (isNaN(fval)) {
    return false
  }
  var f = Math.round(val * 100) / 100
  var s = f.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}
